import React from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  useTheme,
  //useMediaQuery,
  Stack,
  //Paper,
} from "@mui/material";
import Compromise from "../../assets/img/png/10018.png";
import Target from "../../assets/img/png/10016.png";
import Growth from "../../assets/img/png/10017.png";
import Quality from "../../assets/img/png/10012.png";

export const PrincipiosEvalores = () => {
  const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const principles = [
    {
      image: Quality,
      title: "Qualidade em Primeiro Lugar",
      description: "Desde a sua fundação em 2018, a Clima Tropical sempre se comprometeu a fornecer apenas produtos da mais alta qualidade. Acreditamos que nossos clientes merecem o melhor, e é por isso que trabalhamos com equipamentos de ponta para garantir um funcionamento ideal de todos os sistemas de ar condicionado."
    },
    {
      image: Target,
      title: "Foco no Cliente",
      description: "A satisfação do cliente é nossa prioridade. Estamos sempre prontos para ajudar, com um atendimento ao cliente rápido e eficiente, seja para instalar novos sistemas ou reparar sistemas existentes. Nosso compromisso é garantir que o conforto dos nossos clientes nunca seja comprometido."
    },
    {
      image: Growth,
      title: "Crescimento e Inovação",
      description: "Começando em Luanda, expandimos nosso alcance por toda Angola. Continuamos inovando e investindo em nossa equipe de engenheiros altamente qualificados para garantir que possamos oferecer o melhor serviço possível."
    },
    {
      image: Compromise,
      title: "Compromisso com a Comunidade",
      description: "A Clima Tropical está profundamente enraizada na comunidade angolana. Estamos aqui para melhorar a qualidade de vida dos nossos clientes, proporcionando conforto e segurança com nossos sistemas de ar condicionado, especialmente em emergências."
    }
  ];

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: theme.palette.primary.main,
            }}
          >
            Nossos Princípios e Valores
          </Typography>
        </Box>

        {/* Principles Section - Vertical Layout */}
        <Stack spacing={3}>
          {principles.map((principle, index) => (
            <Card
              key={index}
              sx={{
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "translateX(8px)",
                  boxShadow: theme.shadows[4],
                },
                backgroundColor: theme.palette.background.default,
                borderLeft: `6px solid ${theme.palette.primary.main}`,
                borderRadius: 2,
              }}
            >
              <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  {/* Image */}
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: "50%",
                      padding: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={principle.image}
                      alt={principle.title}
                      sx={{
                        width: "60%",
                        height: "60%",
                        objectFit: "contain",
                        filter: "brightness(0) invert(1)",
                      }}
                    />
                  </Box>

                  {/* Content */}
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h5"
                      component="h2"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.primary.main,
                        mb: 2,
                      }}
                    >
                      {principle.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.7,
                      }}
                    >
                      {principle.description}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};